<template>
  <div>
    <div class="Actions__Nav">
      <ul>
        <li v-for="action in actions" :key="action.actionId">
          <button
            @click="actionsOnTank"
            :style="{ color: action.color }"
            :data-action-id="action.actionId"
            :disabled="action.disabled"
            v-if="action.visible"
          >
            <img :src="`../../assets/IkoneMagacin/${action.iconName}.png`" alt="icon" />
            <span>{{action.text}}</span>
          </button>
        </li>
      </ul>

      <div class="Actions__Nav__Select">
        <v-select
          v-model="action_select"
          placeholder="Izaberi akciju"
          class="form-control-select"
          :items="actions"
          @input="actionsOnTank"
        ></v-select>
      </div>
      <!-- /.Actions__Nav__Select -->
    </div>
    <!-- /.Actions__Nav -->

    <div id="Dialog__Overlay" class="Dialog__Overlay v-overlay" style="z-index: 201;"></div>
    <div
      id="Dialog__Content"
      tabindex="-1"
      data-v-fae5bece
      class="Dialog__Content v-dialog__content"
    >
      <div id="Dialog" class="Dialog v-dialog v-dialog--active " v-bind:class="[(this.action === '8' || this.action === '3') ? makaClass : 'siri_modal']">
        <div data-v-fae5bece class="v-card">
          <div data-v-fae5bece class="v-card__title headline lighten-2 v-card__title--primary" style="font-size: 18px!important;">
            <!-- Modal Titles  -->

            <!-- <div
              v-if="this.action === '1'"
            >Flaša / {{ this.naziv_magacina }}</div> -->
            <div id="naslov"
              v-if="this.action === '1'"
            >
            <template v-if="this.naziv_dokumenta !== ''">
              Prijem - {{ this.naziv_dokumenta }}
            </template>
            <template v-else>
              Prijem
            </template>
            
            <img src="../../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="ikona===true">
            </div>
            
            <div id="naslov"
              v-else-if="this.action === '2'"
            >
            <template v-if="this.naziv_dokumenta !== ''">
              Izdavanje - {{ this.naziv_dokumenta }}
            </template>
            <template v-else>
              Izdavanje
            </template>
            <img src="../../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="ikona===true">
            </div>
            
            <div id="naslov"
              v-else-if="this.action === '3'"
            >Međumagacinski prenos</div>
            <div id="naslov"
              v-else-if="this.action === '4'"
            >
            <template v-if="this.naziv_dokumenta !== ''">
              Povraćaj - {{ this.naziv_dokumenta }}
            </template>
            <template v-else>
              Povraćaj
            </template>
            <img src="../../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="ikona===true">
            </div>
            <div id="naslov"
              v-else-if="this.action === '5'"
            >
            <template v-if="this.naziv_dokumenta !== ''">
              Otpis - {{ this.naziv_dokumenta }}
            </template>
            <template v-else>
              Otpis
            </template>
            <img src="../../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="ikona===true">
            </div>
            <div id="naslov"
              v-else-if="this.action === '7'"
            >
            <template v-if="this.naziv_dokumenta !== ''">
              Lansiranje - {{ this.naziv_dokumenta }}
            </template>
            <template v-else>
              Lansiranje
            </template>
            <img src="../../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="ikona===true">
            </div>
            <div id="naslov"
              v-else-if="this.action === '8'"
            >
            <template v-if="this.naziv_dokumenta !== ''">
              Prodaja - {{ this.naziv_dokumenta }}
            </template>
            <template v-else>
              Prodaja
            </template>
            <img src="../../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="ikona===true">
            </div>
            <div id="naslov"
              v-else-if="this.action === '10'"
            >
            <template v-if="this.naziv_dokumenta !== ''">
              Početno stanje - {{ this.naziv_dokumenta }}
            </template>
            <template v-else>
              Početno stanje
            </template>
            <img src="../../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="ikona===true">
            </div>

            <button id="closeModalMagacinBtn" @click="actionsOnTank" class="v-btn v-btn--flat white"
            style="padding-left: 0px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
    width: 40px;
    min-width: 40px;">
              <v-icon>close</v-icon>
            </button>
          </div>

          <div data-v-fae5bece class="spacer"></div>

          <div v-if="this.action === '1'">
            <div v-if="this.tip_magacina === 'bottled_wine'">
              <WareHouseInputBotlle @mounted="customMounted" />
            </div>
            <div v-else>
              <WareHouseInput @mounted="customMounted" />
            </div>
          </div>
          <div v-else-if="this.action === '2'">
            <div v-if="this.tip_magacina === 'bottled_wine'">
              <WareHouseOutputOffWine @mounted="customMounted" />
            </div>
            <div v-else>
              <WareHouseOutputOff @mounted="customMounted" />
            </div>
          </div>
          <div v-else-if="this.action === '3'">
            
            <div v-if="this.tip_magacina === 'bottled_wine'">
              <WareHouseChangeWareHouseWine @mounted="customMounted" />
            </div>
            <div v-else>
              <WareHouseChangeWareHouse @mounted="customMounted" />
            </div>
          </div>
          <div v-else-if="this.action === '4'">
            
            <div v-if="this.tip_magacina === 'bottled_wine'">
              <WareHouseTurnBackWine @mounted="customMounted" />
            </div>
            <div v-else>
              <WareHouseTurnBack @mounted="customMounted" />
            </div>
          </div>
          <div v-else-if="this.action === '5'">
            <div v-if="this.tip_magacina === 'bottled_wine'">
              <WareHouseOutputOffWine @mounted="customMounted" />
            </div>
            <div v-else>
              <WareHouseOutputOff @mounted="customMounted" />
            </div>
          </div>
          <div v-else-if="this.action === '7'">
            <div>
              <WareHouseLaunch @mounted="customMounted" />
            </div>
          </div>
          <div v-else-if="this.action === '8'">
            
            <div v-if="this.tip_magacina === 'bottled_wine'">
              <WareHouseSellingWine @mounted="customMounted" />
            </div>
            <div v-else>
              <WareHouseSelling @mounted="customMounted" />
            </div>
          </div>
          <div v-else-if="this.action === '10'">
            <div v-if="this.tip_magacina === 'bottled_wine'">
              <WareHouseInitialBotlle @mounted="customMounted" />
            </div>
            <div v-else>
              <WareHouseInitial @mounted="customMounted" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { serverBus } from "../../main";

import WareHouseSelling from "./../WareHouseSelling";
import WareHouseSellingWine from "./../WareHouseSellingWine";
import WareHouseOutputOff from "./../WareHouseOutputOff";
import WareHouseOutputOffWine from "./../WareHouseOutputOffWine";
import WareHouseTurnBack from "./../WareHouseTurnBack";
import WareHouseTurnBackWine from "./../WareHouseTurnBackWine";
import WareHouseInputBotlle from "./../WareHouseInputBotlle";
import WareHouseInitialBotlle from "./../WareHouseInitialBotlle";
import WareHouseInitial from "./../WareHouseInitial";
import WareHouseInput from "./../WareHouseInput";
import WareHouseLaunch from "./../WareHouseLaunch";
import WareHouseChangeWareHouse from "./../WareHouseChangeWareHouse";
import WareHouseChangeWareHouseWine from "./../WareHouseChangeWareHouseWine";

const MountedMixin = {
  mounted() {
    this.$emit("mounted");
  }
};

export default {
  name: "ActionsNavMagacin",
  dialog: false,
  data() {
    return {
      makaClass: "dodavanje_merenje",
      action_select: 0,
      action: 0,
      magacinaId: 0,
      naziv_magacina: "",
      tip_magacina: "",
      id_magacina: "",
      tip_magacina_id: "",
      izabrani_red: null,
      naziv_dokumenta: "",
      ikona: false,
      actions: [
        {
          actionId: 1,
          text: "Prijem",
          iconName: "ulaz",
          disabled: false,
          color: "#018389",
          visible: true
        },
        {
          actionId: 2,
          text: "Izdavanje",
          iconName: "izlaz",
          disabled: false,
          color: "#018389",
          visible: true
        },
        {
          actionId: 3,
          text: "Međumagacinski",
          iconName: "medjumagacinski",
          disabled: false,
          color: "#018389",
          visible: true
        },
        {
          actionId: 4,
          text: "Povraćaj",
          iconName: "povracaj",
          disabled: false,
          color: "#018389",
          visible: true
        },
        {
          actionId: 5,
          text: "Otpis",
          iconName: "otpis",
          disabled: false,
          color: "#018389",
          visible: true
        },
        // {
        //   actionId: 6,
        //   text: "Promena pozicije",
        //   iconName: "promena_pozicije",
        //   disabled: false,
        //   color: "#018389"
        // },
        {
          actionId: 7,
          text: "Lansiranje",
          iconName: "lansiranje",
          disabled: false,
          color: "#018389",
          visible: true
        },
        {
          actionId: 8,
          text: "Prodaja",
          iconName: "prodaja",
          disabled: false,
          color: "#018389",
          visible: true
        },
        // {
        //   actionId: 9,
        //   text: "Popis",
        //   iconName: "popis",
        //   disabled: false,
        //   color: "#018389"
        // },
        {
          actionId: 10,
          text: "Početno stanje",
          iconName: "prijem",
          disabled: false,
          color: "#018389",
          visible: true
        }
      ]
    };
  },
  components: {
    WareHouseInputBotlle: resolve => {
      setTimeout(() => {
        const component = WareHouseInputBotlle;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseInitialBotlle: resolve => {
      setTimeout(() => {
        const component = WareHouseInitialBotlle;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseInitial: resolve => {
      setTimeout(() => {
        const component = WareHouseInitial;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseInput: resolve => {
      setTimeout(() => {
        const component = WareHouseInput;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseSelling: resolve => {
      setTimeout(() => {
        const component = WareHouseSelling;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseSellingWine: resolve => {
      setTimeout(() => {
        const component = WareHouseSellingWine;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseOutputOff: resolve => {
      setTimeout(() => {
        const component = WareHouseOutputOff;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseOutputOffWine: resolve => {
      setTimeout(() => {
        const component = WareHouseOutputOffWine;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseTurnBack: resolve => {
      setTimeout(() => {
        const component = WareHouseTurnBack;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseTurnBackWine: resolve => {
      setTimeout(() => {
        const component = WareHouseTurnBackWine;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseChangeWareHouseWine: resolve => {
      setTimeout(() => {
        const component = WareHouseChangeWareHouseWine;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseChangeWareHouse: resolve => {
      setTimeout(() => {
        const component = WareHouseChangeWareHouse;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseLaunch: resolve => {
      setTimeout(() => {
        const component = WareHouseLaunch;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    }
  },
  methods: {
    actionsOnTank(e) {

      

      const Dialog__Content = document.getElementById("Dialog__Content"),
        Dialog__Overlay = document.getElementById("Dialog__Overlay"),
        Tank = document.querySelectorAll(".Tank");

      let vueInstance = this;
      let isOpen = false;
      let isTankSelected = false;
      let magacinaId = 0;
      let tankName = "";

      if (e.target !== undefined) {
        this.action = e.target.dataset.actionId;
      }

      function checkIsTankSelected() {
        for (let i = 0; i < Tank.length; i++) {
          if (Tank[i].classList.contains("active")) {
          magacinaId = Tank[i].dataset.warehouseId;

            vueInstance.magacinaId = Tank[i].dataset.warehouseId;
            vueInstance.warehouse_type = Tank[i].dataset.warehouseType;
            vueInstance.naziv_magacina = Tank[i].dataset.warehouseName;
            vueInstance.warehouse_type_id = Tank[i].dataset.warehouseTypeId;

            isTankSelected = true;
            }
        }
      }

      function modalOpen() {
        if (!isOpen) {
          if (e.target !== undefined) {
            vueInstance.$data.actionId = e.target.dataset.actionId;
          }

          Dialog__Content.style.display = "flex";
          Dialog__Content.classList += " v-dialog__content--active";
          Dialog__Overlay.style.display = "block";
          Dialog__Overlay.classList += " v-overlay--active";

          isOpen = true;
        }
      }

      function modalClose() {
        

        Dialog__Content.style.display = "none";
        Dialog__Content.classList.remove("v-dialog__content--active");
        Dialog__Overlay.style.display = "none";
        Dialog__Overlay.classList.remove("v-overlay--active");

        isOpen = false;
        isTankSelected = false;

        for (let i = 0; i < Tank.length; i++) {
          Tank[i].classList.remove("active");
        }

        if(vueInstance.izabrani_red === null)
          serverBus.$emit("ucitaj_podatke", true);
        else
          serverBus.$emit("ucitaj_podatke", vueInstance.izabrani_red.edit);
            
      }

      if (e.target !== undefined) {
        if (e.target.nodeName !== "UL" && e.target.nodeName !== "DIV") {
          checkIsTankSelected();

          /**
           * SingleTank and EmptyTank
           */
          if(Tank.length > 0)
            if (Tank[0].classList[1] === "TankSingle") {
              magacinaId = Tank[0].dataset.warehouseId;

              vueInstance.magacinaId = Tank[0].dataset.warehouseId;
              vueInstance.warehouse_type = Tank[0].dataset.warehouseType;
              vueInstance.naziv_magacina = Tank[0].dataset.warehouseName;
              vueInstance.warehouse_type_id = Tank[0].dataset.warehouseTypeId;

              isTankSelected = true;
            }

          this.naziv_magacina = vueInstance.naziv_magacina;
          this.tip_magacina = vueInstance.warehouse_type;
          this.id_magacina = vueInstance.magacinaId;
          this.tip_magacina_id = vueInstance.warehouse_type_id;
        }

        /**
         * Close Modal
         */
        if (e.target.id === "closeModalMagacinBtn") {
          modalClose();

          
          this.izabrani_red = null;
          this.naziv_dokumenta = "";
          this.ikona = false;

          this.action_select = "undefined";
        } else {
          /**
           * Open Modal
           */

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali magacin.");
          }
        }
      } else {
        checkIsTankSelected();

        if(Tank.length > 0)
          if (Tank[0].classList[1] === "TankSingle") {
            magacinaId = Tank[0].dataset.warehouseId;

            vueInstance.magacinaId = Tank[0].dataset.warehouseId;
            vueInstance.warehouse_type = Tank[0].dataset.warehouseType;
            vueInstance.naziv_magacina = Tank[0].dataset.warehouseName;
            vueInstance.warehouse_type_id = Tank[0].dataset.warehouseTypeId;

            isTankSelected = true;
          }

        // // console.log(Tank[0].dataset);

        this.naziv_magacina = vueInstance.naziv_magacina;
        this.tip_magacina = vueInstance.warehouse_type;
        this.id_magacina = vueInstance.magacinaId;
        this.tip_magacina_id = vueInstance.warehouse_type_id;



        if (e === "Prijem") {
          if (!this.disable) {
            vueInstance.action = "1";
            vueInstance.$data.actionId = 1;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali magacin");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "Početno stanje") {
          if (!this.disable) {
            vueInstance.action = "10";
            vueInstance.$data.actionId = 10;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali magacin");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "Prodaja") {
          if (!this.disable) {
            vueInstance.action = "8";
            vueInstance.$data.actionId = 8;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali magacin");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "Izdavanje") {
          if (!this.disable) {
            vueInstance.action = "2";
            vueInstance.$data.actionId = 2;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali magacin");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "Otpis") {
          if (!this.disable) {
            vueInstance.action = "5";
            vueInstance.$data.actionId = 5;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali magacin");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "Međumagacinski prenos" || e === "Međumagacinski") {
          if (!this.disable) {
            vueInstance.action = "3";
            vueInstance.$data.actionId = 3;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali magacin");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "Povraćaj") {
          if (!this.disable) {
            vueInstance.action = "4";
            vueInstance.$data.actionId = 4;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali magacin");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "Lansiranje") {
          if (!this.disable) {
            vueInstance.action = "7";
            vueInstance.$data.actionId = 7;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali magacin");
            }
          } else
            alert(
              "Alert"
            );
        }
      }

      return magacinaId;
    },
    customMounted() {
      if (this.action === "1") {

        serverBus.$emit(
          "wh_input",
          this.id_magacina,
          this.tip_magacina,
          this.izabrani_red
        );
      }  else if (this.action === "10") {

        serverBus.$emit(
          "wh_init",
          this.id_magacina,
          this.tip_magacina,
          this.izabrani_red
        );

      }  else if (this.action === "2" || this.action === "5") {
        serverBus.$emit(
          "wh_outputoff",
          this.id_magacina,
          this.tip_magacina,
          this.action,
          this.izabrani_red
        );

      } else if (this.action === "8") {
        serverBus.$emit(
          "wh_selling",
          this.id_magacina,
          this.tip_magacina,
          this.izabrani_red
        );

      } else if (this.action === "3") {
        serverBus.$emit(
          "wh_change",
          this.id_magacina,
          this.tip_magacina,
          this.tip_magacina_id,
          this.izabrani_red
        );

      } else if (this.action === "4") {
        serverBus.$emit(
          "wh_turnback",
          this.id_magacina,
          this.tip_magacina,
          this.tip_magacina_id,
          this.izabrani_red
        );

      } else if (this.action === "7") {
        serverBus.$emit(
          "wh_launch",
          this.id_magacina,
          this.tip_magacina,
          this.tip_magacina_id,
          this.izabrani_red
        );

      }
    }
  },
  mounted() {
    serverBus.$on("open_modal", (akcija, e, item) => {
      this.izabrani_red = item;

      if(item.number !== null && item.number !== undefined)
        this.naziv_dokumenta = item.number;
      else
        this.naziv_dokumenta = item.documentNumber;

      this.ikona = item.executed;



      this.actionId = akcija;

      this.actionsOnTank(e);

    })

    serverBus.$off("disable_action_warehouse");

    serverBus.$on("disable_action_warehouse", nizVred => {
      // alert(disable);
      //this.pom_disable = disable;

      let i = 0;

      while (i < nizVred.length) {
        this.actions[i].disabled = nizVred[i];

        if (nizVred[i]) {
          this.actions[i].iconName =
            this.actions[i].iconName.replace("-grey", "") + "-grey";
          this.actions[i].color = "#c3c3c3";
          this.actions[i].visible = false;
        } else {
          this.actions[i].iconName = this.actions[i].iconName.replace(
            "-grey",
            ""
          );
          this.actions[i].color = "#018389";
          this.actions[i].visible = true;
        }

        i++;
      }
    });
  }
  //}
};
</script>
<style scoped lang='scss'>
@import "./../parts/../../assets/sass/parts/modalStyles_siri_modal";

.Actions__Nav {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 20;
  left: $closedNavWidth;
  padding: 10px 130px 10px 60px;
  background-color: rgb(247, 247, 247);
  @media (max-width: 1200px) {
    height: 71px;
    padding-top: 10px;
    padding-right: 55px;
  }
  ul {
    display: flex;
    // flex-wrap: wrap;
    align-items: center;
    list-style-type: none;
    justify-content: space-between;
    padding-left: 0;
    @media (max-width: 1200px) {
      display: none;
    }
    button {
      // color: #018389;
      font-weight: 300;
      letter-spacing: 0;
      text-decoration: none;
      text-transform: uppercase;
      font-family: "NunitoSans", sans-serif;
      // &:focus {
      //   outline: 1px solid #018389;
      // }
      > * {
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
        pointer-events: none;
      }
      img {
        margin-right: 7px;
        width: 37px;
        height: 37px;
      }
    }
    
    button:hover{
  transform:scale(1.2);
  transition: all .4s ease-in-out;
}
  }
  &__Select {
    display: none;
    @media (max-width: 1200px) {
      display: block;
      width: 200px;
      float: right;
    }
  }
}
</style>